<template>
	<el-dialog :visible.sync="is_visible" :width="'30%'" @close="hide">
		<template slot="title">
			<div>
				<h3 class="mb-0 font-weight-500">{{ is_update ? 'Update Salutation' : 'Add Salutation' }}</h3>
			</div>
		</template>
		<b-form>
				<b-row>
						<!-- FIELD CHANNEL NAME -->
						<b-col cols="12" md="12">
								<b-form-group label="Type">
										<b-form-input
												v-model="formData.text"
												type="text"
												required
												readonly
												></b-form-input>
								</b-form-group>
						</b-col>
						<b-col cols="12" md="12">
								<b-form-group label="Default Value">
										<b-form-input
												v-model="formData.setting"
												type="number"
												step="0.01"
												></b-form-input>
								</b-form-group>
						</b-col>
						<b-col cols="12" md="12">
								<b-form-group label="Description">
										<b-form-input
												v-model="formData.description"
												type="text"
												></b-form-input>
								</b-form-group>
						</b-col>
						<!-- <b-col cols="12" md="12">
								<b-form-group label="Squence">
										<b-form-input
												v-model="formData.seq"
												type="number"
												></b-form-input>
								</b-form-group>
						</b-col> -->
						<!-- FIELD HUB -->
						<b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
							<el-button type="primary"  @click="submit()" :loading="is_loading_btn">{{ is_update ? 'Save' : 'Create' }}</el-button>
						</b-col>
				</b-row>
		</b-form>
	</el-dialog>
</template>
<script>
import { Select, Option, Dialog, Button } from 'element-ui'
import { mapActions } from 'pinia'
import { useInvinityStore } from '@/stores/invinityStore'

export default {
	components: {
		[Button.name]: Button,
		[Select.name]: Select,
		[Option.name]: Option,
		[Dialog.name]: Dialog,
	},    
	data() {
			return {
				is_visible: false,
				is_update: false,
				is_loading_btn: false,
				formData:{
					id:null,
					text: '',
					value: '',
					type: 'lec_other_payment',
					setting: 0,
					description: ''
				}
			}
	},
	methods:{
		...mapActions(useInvinityStore, ['createDropdownList', 'updateDropdownList']),
		show(item={}){
			if(!_gHlp.isEmpty(item)){
				this.formData = {...this.formData,...item};
				this.is_update = true;
			}else{
				this.formData = _gHlp.resetFormAttributes(this.formData);
				this.is_update = false;
			}
			this.is_visible = true
		},
		hide(){
			this.formData = _gHlp.resetFormAttributes(this.formData);
			this.is_update = false
			this.is_visible = false
			this.is_loading_btn = false
		},
		async submit(){
			this.is_loading_btn = true
			let resp = null;
			let params = {
				type: 'lec_other_payment',
				text: this.formData.text,
				value: this.formData.value,
				setting: this.formData.setting,
				description: this.formData.description,
			}
			if(this.is_update){
				resp = await this.updateDropdownList(this.formData.id,params)
				if(!_gHlp.isEmpty(resp)){
					_gNotif.notifySuccess('<b>Fees & Charges:</b> - Successfully Updated.',10000,'success');
				}
			}else{
				resp = await this.createDropdownList(params)
				if(!_gHlp.isEmpty(resp)){
					_gNotif.notifySuccess('<b>Fees & Charges:</b> - Successfully Created.',10000,'success');
				}
			}
			if(!_gHlp.isEmpty(resp)){
				this.$emit('refresh', true)
				this.hide();
			}
		}
	}
}
</script>